import { customElement, bindable } from "aurelia-framework";

@customElement("toolbar-button")
export class ToolbarButton {
    @bindable title;
    @bindable src;
}

